import { render, staticRenderFns } from "./CheckboxesForm.vue?vue&type=template&id=1654aad8&"
import script from "./CheckboxesForm.vue?vue&type=script&lang=js&"
export * from "./CheckboxesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports